var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading,"small":""},on:{"click":_vm.handler}},[_vm._v("Rebuild EventOrder")])
}
var staticRenderFns = []

export { render, staticRenderFns }